import React from 'react'
import { Button } from '@mui/material'

interface ActionButtonProps {
  icon: React.ReactElement
  label: string
  onClick: () => void
  /** Set by DisabledReason, with the reason as the accessible description. */
  disabled?: boolean
  'aria-describedby'?: string
}

const ActionButton: React.FC<ActionButtonProps> = ({ icon, label, onClick, disabled, 'aria-describedby': describedBy }) => (
  <Button
    variant="text"
    startIcon={icon}
    onClick={onClick}
    disabled={disabled}
    aria-describedby={describedBy}
    sx={{
      fontSize: '0.8125rem',
      px: 1.5,
      py: 0.75,
      borderRadius: '6px',
      color: 'text.secondary',
      '&:hover': {
        backgroundColor: 'action.hover',
        color: 'text.primary',
      },
    }}
  >
    {label}
  </Button>
)

export default ActionButton
